module.exports = __webpack_public_path__ + "static/media/PlayfairDisplay-Regular.c9ce414e.eot";